import photo1 from "/public/images/events/forum-association/forum-association-21/photo1.webp";
import photo2 from "/public/images/events/forum-association/forum-association-21/photo2.webp";
import photo3 from "/public/images/events/forum-association/forum-association-21/photo3.webp";
import photo4 from "/public/images/events/forum-association/forum-association-21/photo4.webp";
import photo5 from "/public/images/events/forum-association/forum-association-21/photo5.webp";

export const forumAssociation21Images = [
  {
    src: photo1,
    alt: "Forum Association 2021 - Photo 1",
    format: "2:3" as const,
  },
  {
    src: photo2,
    alt: "Forum Association 2021 - Photo 2",
    format: "3:2" as const,
  },
  {
    src: photo3,
    alt: "Forum Association 2021 - Photo 3",
    format: "3:2" as const,
  },
  {
    src: photo4,
    alt: "Forum Association 2021 - Photo 4",
    format: "3:2" as const,
  },
  {
    src: photo5,
    alt: "Forum Association 2021 - Photo 5",
    format: "3:2" as const,
  },
];
